import { render, staticRenderFns } from "./ShadowButton.vue?vue&type=template&id=47b334b4&scoped=true&"
import script from "./ShadowButton.vue?vue&type=script&lang=js&"
export * from "./ShadowButton.vue?vue&type=script&lang=js&"
import style0 from "./ShadowButton.vue?vue&type=style&index=0&id=47b334b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b334b4",
  null
  
)

export default component.exports